<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
    <v-btn icon style="margin-top: 14px" slot="activator" :disabled="(sitenotifications.length === 0) === true">
      <v-badge color="red" left overlap :value="unseenCount">
        <span slot="badge">{{unseenCount}}</span>
        <v-icon>notifications</v-icon>
      </v-badge>
    </v-btn>
    <v-card flat>
      <v-card-title class="headline mb-3">
        <v-toolbar flat fixed class="pr-4">
          <span>Уведомления</span>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="px-0 mx-0">
        <v-card light flat class="py-3 px-2 mx-0"
          v-for="item in sitenotifications" :key="item.sitenotificationid"
          :color="item.seen ? 'grey lighten-5' : 'yellow lighten-4'">
          <v-toolbar color="#FFD052" light
            flat v-observe-visibility="e => { if (e && !item.seen && !item.sawInProgress) saw(item) }">
            <h3><b>{{ts(item.cts)}}</b></h3>
          </v-toolbar>
          <v-card-text>
            <span v-html="item.content"></span>
          </v-card-text>
          <br>
        </v-card>
        <v-content v-if="sitenotifications.length === 0">
          <v-container fill-height>
            <v-layout justify-center align-center>
              <v-flex shrink>
                <h1>Нет уведомлений</h1>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  name: 'site-notifications',
  data: () => ({
    sitenotifications: [],
    dialog: false
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    unseenCount () {
      return this.sitenotifications.filter(x => !x.seen).length
    }
  },
  methods: {
    async fetch () {
      const { sitenotifications } = await this.fetchNotifications()
      this.sitenotifications = sitenotifications
    },
    async fetchNotifications () {
      return this.$store.dispatch('sioRequest', {
        topic: 'sitenotifications',
        pl: { personid: this.profile.personid }
      })
    },
    ts (ts) {
      return moment(ts).format('YYYY-MM-DD HH:MM:ss')
    },
    saw (notification) {
      setTimeout(() => {
        notification.seen = true
      }, 800)
      notification.sawInProgress = true
      this.$store.dispatch('sioRequest', {
        topic: 'sitenotifications-saw',
        pl: { sitenotificationid: notification.sitenotificationid }
      })
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>
